import { render, staticRenderFns } from "./InsertEnterCastleData.vue?vue&type=template&id=2522805d&scoped=true"
import script from "./InsertEnterCastleData.vue?vue&type=script&lang=js"
export * from "./InsertEnterCastleData.vue?vue&type=script&lang=js"
import style0 from "./InsertEnterCastleData.vue?vue&type=style&index=0&id=2522805d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2522805d",
  null
  
)

export default component.exports